import { fetchIncreaseAllowance } from "@services/vesselService";
import { Modal } from "flowbite-react";
import { useState } from "react";
import { customModalTheme } from "styles/customTheme";

export const ModalCorporateAllowance = ({
	isOpen,
	closeModal,
	vesselId,
	vesselName,
	token,
	fetchConfigurations,
}) => {
	const [loadingSubmit, setLoadingSubmit] = useState(false);
	const [errors, setErrors] = useState({});
	const [errorMessage, setErrorMessage] = useState("");
	const [successMessage, setSuccessMessage] = useState("");

	const handleSubmit = async () => {
		setLoadingSubmit(true);
		setErrorMessage("");

		try {
			const res = await fetchIncreaseAllowance(vesselId, token);

			const message = res?.message || "Allowance increased successfully";

			await fetchConfigurations();
			setSuccessMessage(message);
			setTimeout(() => {
				closeModal();
			}, 1200);
		} catch (err) {
			const message = err.message || "Something went wrong";
			setErrorMessage(message);
		} finally {
			setLoadingSubmit(false);
		}
	};

	return (
		<>
			<Modal show={isOpen} onClose={closeModal} size="4xl" theme={customModalTheme}>
				<Modal.Header className="border-none bg-gray-900" />
				<Modal.Body className="custom-scrollbar border-border_bottom">
					<div className="space-y-4">
						<div className="flex items-center justify-center">
							<div className="text-center">
								<p>
									Are you sure you want to increase the corporate allowance for{" "}
									<strong>{vesselName}</strong> by <strong>50 GB</strong>?
								</p>
							</div>
						</div>
						<div className="text-center">
							{errorMessage && <p className="text-red-500 text-sm">{errorMessage}</p>}
							{successMessage && <p className="text-green-500 text-sm">{successMessage}</p>}
						</div>
					</div>
				</Modal.Body>

				<Modal.Footer className="flex justify-center border-t border-none">
					<>
						<button
							type="button"
							onClick={() => handleSubmit()}
							disabled={loadingSubmit}
							className="mr-2 rounded-lg bg-button-bg px-4 py-2 text-[14px] text-white hover:bg-button-hover disabled:opacity-50"
						>
							{loadingSubmit ? "Processing..." : "Confirm"}
						</button>
						<button
							type="button"
							className="rounded-lg border-gray-600 bg-gray-200 px-4 py-2 text-[14px] text-blue-gray hover:bg-white hover:text-dark-blue focus:z-10 focus:outline-none focus:ring-4 focus:ring-gray-200"
							onClick={closeModal}
						>
							No, cancel
						</button>
					</>
				</Modal.Footer>
			</Modal>
		</>
	);
};
